import React from 'react'
import { observer } from 'mobx-react-lite'

import { Checkbox, TableCell } from '@material-ui/core'

import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked'
import CircleCheckedFilled from '@material-ui/icons/CheckCircle'
import { ITableData } from '../../../../types/tableTypes'
import { useMessages } from '../../../../hooks/snackbarHooks'
import { useStore } from '../../../../hooks/storeHook'

interface ISelectCellProps<TRow extends object, TColumnId extends string> {
  row: TRow,

  table: ITableData<TRow, TColumnId>
}

export const TableSelectCell =
  observer(
    <TRow extends object, TColumnId extends string>
    ({row, table}: ISelectCellProps<TRow, TColumnId>) => {
      const {selectedRowCount, isRowSelected, toggleRowSelection} = table

      const {showError} = useMessages()

      const {mpcardStore: {addRow, deleteRow}} = useStore()

      const onToggleRowSelection = () => {
        if (selectedRowCount === 5 && !isRowSelected(row)) {
          showError('Для выбора доступно максимум 5 карточек')
          return
        }

        isRowSelected(row) ? deleteRow(row) : addRow(row)

        toggleRowSelection(row)
      }

      return (
        <TableCell
          className="table-border"
          padding="checkbox"
          onClick={onToggleRowSelection}
          style={{cursor: 'pointer'}}
        >
          <Checkbox
            checked={isRowSelected(row)}
            style={{color: '#3987cf'}}
            icon={<CircleUnchecked/>}
            checkedIcon={<CircleCheckedFilled style={{color: '#3987cf'}}/>}/>
        </TableCell>
      )
    })